import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";

export const AuthCallback = () => {
  const hasProcessed = useRef(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    const target = sessionStorage.getItem("vsi_post_login") || location.pathname || "/";
    sessionStorage.removeItem("vsi_post_login");
    api.post("/auth/session", { session_id: sessionId })
      .then(({ data }) => { setUser(data); toast.success(`Welcome, ${data.name || data.email}`); })
      .catch(() => toast.error("Google sign-in failed. Please try again."))
      .finally(() => navigate(target, { replace: true }));
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-callback-loading">
      <Loader2 className="h-6 w-6 animate-spin text-primary" />
    </div>
  );
};
